// src/components/Admin/AdminLayout.jsx
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { initializeAuth } from '../../redux/features/authSlice';
import AdminSidebar from './AdminSidebar';
import PageLoader from '../PageLoader';

const AdminLayout = () => {
    const dispatch = useDispatch();
    const { user, isInitialized } = useSelector(state => state.auth);

    useEffect(() => {
        dispatch(initializeAuth());
    }, [dispatch]);

    if (!isInitialized) {
        return <PageLoader />;
    }

    if (!user) {
        return <Navigate to="/admin/login" replace />;
    }

    return (
        <div className="flex h-screen bg-gray-100">
            <AdminSidebar />
            <main className="flex-1 overflow-x-hidden overflow-y-auto">
                <div className="container mx-auto px-6 py-8">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default AdminLayout;
